import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 2,
    width: '450px',
  },
});

function Loader(props) {
  const { classes, loaderText } = props;
  return (
    <div>
      <h3>{loaderText}</h3>
      <CircularProgress className={classes.progress} size={50} />
    </div>
  );
}

Loader.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Loader);



// WEBPACK FOOTER //
// ./src/components/Loader.js